import { render, staticRenderFns } from "./DepartamentoPage.vue?vue&type=template&id=4d211661"
import script from "./DepartamentoPage.js?vue&type=script&lang=js&external"
export * from "./DepartamentoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports